import type { LucideIcon } from 'lucide-react'

import { Brain, HeartPulse, Salad } from 'lucide-react'

export type HubNav = {
    slug: string
    name: string
    tagline: string
}

export const HUBS: HubNav[] = [
    { slug: 'mental-health', name: 'Mental Health', tagline: 'Mind, mood, and resilience' },
    { slug: 'physical-health', name: 'Physical Health', tagline: 'Movement, recovery, and prevention' },
    { slug: 'nutrition-wellness', name: 'Nutrition & Wellness', tagline: 'Food, energy, and daily habits' }
]

export type HubTheme = {
    icon: LucideIcon
    text: string
    ink: string
    softBg: string
    solidBg: string
    border: string
    borderAccent: string
    ring: string
    dot: string
}

export const HUB_THEME: Record<string, HubTheme> = {
    'mental-health': {
        icon: Brain,
        text: 'text-mental',
        ink: 'text-mental-ink',
        softBg: 'bg-mental-soft',
        solidBg: 'bg-mental',
        border: 'border-mental/25',
        borderAccent: 'border-l-mental',
        ring: 'ring-mental/30',
        dot: 'bg-mental'
    },
    'physical-health': {
        icon: HeartPulse,
        text: 'text-physical',
        ink: 'text-physical-ink',
        softBg: 'bg-physical-soft',
        solidBg: 'bg-physical',
        border: 'border-physical/25',
        borderAccent: 'border-l-physical',
        ring: 'ring-physical/30',
        dot: 'bg-physical'
    },
    'nutrition-wellness': {
        icon: Salad,
        text: 'text-nutrition',
        ink: 'text-nutrition-ink',
        softBg: 'bg-nutrition-soft',
        solidBg: 'bg-nutrition',
        border: 'border-nutrition/25',
        borderAccent: 'border-l-nutrition',
        ring: 'ring-nutrition/30',
        dot: 'bg-nutrition'
    }
}

export const getHubTheme = (slug: string): HubTheme => HUB_THEME[slug] ?? HUB_THEME['mental-health']

export const getHubName = (slug: string): string =>
    HUBS.find(hub => hub.slug === slug)?.name ?? slug
